export default __webpack_public_path__ + "static/media/1.5831b7c1.jpg";